export const quickstock = {
  quickstock: {
    legend: {
      stock: 'Stock Disponible',
      nostock: 'Sin Stock',
      lowstock: 'Stock Limitado'
    },
    errors: {
      subcategories: 'Error en el servidor, no se pudieron cargar las subcategorías.',
      categories: 'Error en el servidor, no se pudieron cargar las categorías.',
      nostock: "Producto sin stock.",
    },
    notification: {
      title: 'Notificarme',
      alert: 'Sé el primero en enterarte',
      alertunsubscribe: 'Si anula la suscripción no recibirá una notificación cuando el producto vuelva a estar en stock. ¿Desea continuar?',
      explanation: 'Se le notificará ni bien el artículo vuelva a estar en stock.',
      selectnotifications: 'Seleccione cómo le gustaría recibir las notificaciones.',
      email: 'Correo electrónico',
      cancel: 'Cancelar',
      subscribe: 'Suscribirse',
      unsubscribe: 'Anular la Suscripción',
      updated: '¡Solicitud realizada con éxito!'
    }
  }
};
